import React from 'react';
import { AnswerInput, useProgram } from 'shared/providers/ProgramProvider';
import BudgetSummary from 'npo/pages/ReportBuilder/Components/Budget/BudgetSummary';
import { GuidanceTextResponse } from 'npo/pages/ReportBuilder/Components/utils';
import { FeedbackCommentBodyWithIndex } from 'npo/pages/NPOFeedback/utils';
import { ReportsTable } from '../ReportGroup';

const emptyGuidance: GuidanceTextResponse = {};
const emptyFeedback: { [id: number]: FeedbackCommentBodyWithIndex[] } = {};

interface Props {
  value: AnswerInput;
  onChange: (next: AnswerInput) => void;
  report: ReportsTable;
}

const noop = () => undefined;

// Adapts BudgetSummary (question 80011) to the ReportsBeta program-question
// flow: internal BottomBar is hidden, BudgetSummary's onValueChange emitter
// keeps AnswerInput in sync so the outer wizard footer persists via the
// standard save flow. `values` comes from the shared ProgramContext's answer
// map so the direct/overhead/in-kind inputs pre-populate from prior answers.
const BudgetSummaryField: React.FC<Props> = ({ value, onChange, report }) => {
  const { answersTextById } = useProgram();

  const handleValueChange = (nextText: string) => {
    onChange({ ...value, text: nextText });
  };

  return (
    <BudgetSummary
      values={answersTextById}
      initialValue={value.text ?? undefined}
      reportId={report.dbId}
      guidanceText={emptyGuidance}
      hideBottomBar={true}
      feedbackByQuestionId={emptyFeedback}
      onNext={noop}
      onPrevious={noop}
      onValueChange={handleValueChange}
    />
  );
};

export default BudgetSummaryField;
